function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { isFunction } from '@cloud-sn/v-utils';
import { BlobSlice, getChunkUploadBytes } from '../utils';
export default function chunkRequest(request, reqs) {
  var nReqs = reqs;
  return function (options) {
    var maxChunkSize = options.maxChunkSize,
        uploadedBytes = options.uploadedBytes,
        onChunkSend = options.onChunkSend,
        onChunkSuccess = options.onChunkSuccess,
        onChunkError = options.onChunkError,
        reqOpts = _objectWithoutProperties(options, ["maxChunkSize", "uploadedBytes", "onChunkSend", "onChunkSuccess", "onChunkError"]);

    var fileName = reqOpts.fileName,
        file = reqOpts.file,
        data = reqOpts.data,
        _onProgress = reqOpts.onProgress,
        _onSuccess = reqOpts.onSuccess,
        _onError = reqOpts.onError;
    var uid = file.uid;
    var ubytesRet = isFunction(uploadedBytes) ? uploadedBytes(file, data) : uploadedBytes;
    Promise.resolve(ubytesRet).then(function (ubytes) {
      var idx = 0;
      var ub = Number(ubytes) || 0;
      var maxSize = Number(maxChunkSize);
      var fileSize = file.size;

      if (ub || maxSize < fileSize) {
        if (ub >= fileSize) {
          _onError(new Error('uplodedbytes > file.size'), null);

          return;
        }

        var chunkUploadFn = function chunkUploadFn() {
          idx += 1;
          var chunkId = "chunk-".concat(uid, "-").concat(idx);
          var chunkName = "".concat(fileName, "-chunk-").concat(idx);
          var chunk = BlobSlice.call(file, ub, ub + maxSize, file.type);
          var chunkSize = chunk.size;
          var nFile = new File([chunk], chunkName, {
            type: file.type
          });
          var startOffset = ub; // eslint-disable-next-line

          var endOffset = ub + chunkSize - 1;
          var range = "bytes ".concat(startOffset, "-").concat(endOffset, "/").concat(fileSize);
          var disposition = "attachment; filename=\"".concat(encodeURI(file.name), "\"");

          var headers = _objectSpread({}, options.headers, {
            'Content-Range': range,
            'Content-Disposition': disposition
          });

          var formData = _objectSpread({}, data, {
            chunkData: JSON.stringify({
              uuid: "chunk-upload-".concat(uid),
              size: fileSize,
              chunkIdx: idx,
              start: startOffset,
              end: endOffset,
              isLastChunk: endOffset + 1 === fileSize
            })
          });

          var chunkEventData = {
            file: file,
            chunkId: chunkId,
            chunk: chunk,
            chunkSize: chunkSize,
            chunkIdx: idx,
            startOffset: startOffset,
            endOffset: endOffset,
            contentRange: range,
            data: data
          };
          onChunkSend(chunkEventData);
          nReqs[chunkId] = request(_objectSpread({}, reqOpts, {
            file: nFile,
            headers: headers,
            data: formData,
            onProgress: function onProgress(e) {
              if (fileSize > 0) {
                // eslint-disable-next-line
                e.percent = ub / fileSize * 100;
              }

              _onProgress(e);
            },
            onSuccess: function onSuccess(ret, xhr) {
              ub = getChunkUploadBytes(xhr) || ub + chunkSize;
              onChunkSuccess(ret, _objectSpread({}, chunkEventData, {
                xhr: xhr
              }));

              if (ub < fileSize) {
                chunkUploadFn();
              } else {
                _onSuccess(ret, file, xhr);
              }
            },
            onError: function onError(err, ret) {
              onChunkError(err, ret, _objectSpread({}, chunkEventData));

              _onError(err, ret);
            }
          }));
        };

        chunkUploadFn();
      } else {
        nReqs[uid] = request(reqOpts);
      }
    });
  };
}